/*
  TODO:

  Leaving this as a separate folder for now, but it probably be moved
  to /context. If this goes into /context, then the associated styled.ts
  file can be moved elsewhere.
*/
import { Global, css } from '@emotion/react';

const resets = css`
  /*
    http://meyerweb.com/eric/tools/css/reset/
    v2.0 | 20110126
    License: none (public domain)
  */

  html,
  body,
  div,
  span,
  applet,
  object,
  iframe,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p,
  blockquote,
  pre,
  a,
  abbr,
  acronym,
  address,
  big,
  cite,
  code,
  del,
  dfn,
  em,
  img,
  ins,
  kbd,
  q,
  s,
  samp,
  small,
  strike,
  strong,
  sub,
  sup,
  tt,
  var,
  b,
  u,
  i,
  center,
  dl,
  dt,
  dd,
  ol,
  ul,
  li,
  fieldset,
  form,
  label,
  legend,
  table,
  caption,
  tbody,
  tfoot,
  thead,
  tr,
  th,
  td,
  article,
  aside,
  canvas,
  details,
  embed,
  figure,
  figcaption,
  footer,
  header,
  hgroup,
  menu,
  nav,
  output,
  ruby,
  section,
  summary,
  time,
  mark,
  audio,
  video {
    margin: 0;
    padding: 0;
    border: 0;
    font-size: 100%;
    font: inherit;
    vertical-align: baseline;
  }
  /* HTML5 display-role reset for older browsers */
  article,
  aside,
  details,
  figcaption,
  figure,
  footer,
  header,
  hgroup,
  menu,
  nav,
  section {
    display: block;
  }
  body {
    line-height: 1;
  }
  ol,
  ul {
    list-style: none;
  }
  blockquote,
  q {
    quotes: none;
  }
  blockquote:before,
  blockquote:after,
  q:before,
  q:after {
    content: '';
    content: none;
  }
  table {
    border-collapse: collapse;
    border-spacing: 0;
  }

  *,
  *:before,
  *:after {
    box-sizing: border-box;
    -webkit-font-smoothing: antialiased;
  }

  #root {
    /*
      Create a stacking context, without a z-index.
      This ensures that all portal content (modals and tooltips) will
      float above the app.
    */
    isolation: isolate;
  }

  html,
  body,
  #root {
    font-family: var(--font-sans);
  }

  pre,
  code,
  kbd,
  samp {
    font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas,
      'Liberation Mono', 'Courier New', monospace;
  }
`;

const variables = css`
  html {
    --brand-primary: hsla(281, 53%, 33%, 1);
    --brand-primary-10: rgba(100, 39, 128, 0.1);
    --brand-primary-06: rgba(100, 39, 128, 0.06);
    --brand-secondary: hsla(281, 53%, 33%, 0.1);
    --brand-black: hsla(234, 8%, 23%, 1);
    --brand-black-70: hsla(234, 8%, 23%, 0.7);
    --brand-black-20: hsla(234, 8%, 23%, 0.2);
    --brand-grey-70: hsla(300, 10%, 32%, 0.7);
    --brand-grey-10: hsla(300, 10%, 32%, 0.1);
    --brand-background: hsla(300, 10%, 96%, 1);
    --font-sans: 'Helvetica Neue', Helvetica, sans-serif;

    /*
      TODO:

      * Not sure if the names here accurately reflects what's on Figma
      see: https://www.figma.com/file/tHp8K7uZT6k9LWabszIwHt/C.to-Admin?node-id=605%3A14732

      *Regarding the green colors, there is another palete defined for the status tags
      see: https://www.figma.com/file/tHp8K7uZT6k9LWabszIwHt/C.to-Admin?node-id=310%3A8898

    */
    --brand-green: hsla(147, 69%, 70%, 1);
    --brand-green-secondary: hsla(97, 64%, 51%, 1);
    --brand-green-secondary-10: hsla(97, 64%, 51%, 0.1);
    --brand-blue-10: hsla(188, 95%, 62%, 0.1);
    --brand-red: hsla(355, 100%, 75%, 1);
    --brand-red-10: hsla(355, 100%, 75%, 0.1);
    --brand-orange: hsla(38, 87%, 66%, 1);
    --brand-orange-10: hsla(38, 87%, 66%, 0.1);
    --brand-purple: hsla(238, 44%, 71%, 1);
    --brand-white: hsla(0, 0%, 100%, 1);
    --mui-error-red: hsla(0, 65%, 51%, 1);

    background: var(--brand-background);
  }

  @font-face {
    font-family: 'FuturaStd';
    font-weight: 700;
    font-display: swap;
    src: url(/fonts/futura/FuturaStd-Bold.woff2) format('woff2'),
      url(/fonts/futura/FuturaStd-Bold.ttf) format('truetype');
  }

  html,
  body {
    height: 100%;
    background-color: #fff;
  }

  h6 {
    font-family: 'FuturaStd';
    font-weight: bold;
  }
`;

const globalStyles = css`
  ${resets}
  ${variables}
`;

function GlobalStyles() {
  return <Global styles={globalStyles} />;
}

export { GlobalStyles };
